import { useMemo } from 'react'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { bigNumberify } from '@/utils/bigNumber'
import type { EVaultData } from './useEVaults'

export interface EarnStats {
  totalTVL: NormalizedUnitNumber
}

/**
 * Calculate aggregate statistics for Earn vaults
 * @param vaults - Array of vault data to aggregate
 * @returns Aggregate stats including total TVL
 */
export function useEarnStats(vaults: EVaultData[]): EarnStats {
  return useMemo(() => {
    const totalTVLBN = vaults.reduce((acc, vault) => {
      if (vault.tvlUsd) {
        return acc.plus(vault.tvlUsd.toString())
      }
      return acc
    }, bigNumberify(0))

    return {
      totalTVL: NormalizedUnitNumber(totalTVLBN),
    }
  }, [vaults])
}
